import '@vue-flow/core/dist/style.css'
import '@vue-flow/core/dist/theme-default.css'
import '@vue-flow/controls/dist/style.css'
import '@vue-flow/minimap/dist/style.css'
import '@/styles'

import { VueQueryPlugin } from '@tanstack/vue-query'
import { createPinia } from 'pinia'
import { createApp } from 'vue'

import App from './App.vue'
import { installDeploymentRecovery } from './deploymentRecovery'
import { installAppComponents } from './plugins/appComponents'
import { vuetify } from './plugins/vuetify'
import { queryClient } from './queryClient'
import { router } from './router'
import { initializePortalPwa } from './portal/pwa'

installDeploymentRecovery()
initializePortalPwa(true)

const app = createApp(App)

installAppComponents(app)
app.use(createPinia())
app.use(VueQueryPlugin, { queryClient })
app.use(vuetify)
app.use(router)
app.mount('#app')
